/** Numbers and dates as the charts write them. Pure, tested in chart.test.ts. */

/** Round tick values: 0, 2K, 4K… with at most `count` steps. */
export function niceTicks(max: number, count = 4): number[] {
  if (!(max > 0)) return [0, 1];
  const raw = max / count;
  const mag = 10 ** Math.floor(Math.log10(raw));
  const step = [1, 2, 2.5, 5, 10].map((m) => m * mag).find((s) => s >= raw) ?? raw;
  const top = Math.ceil(max / step) * step;
  const out: number[] = [];
  for (let v = 0; v <= top + step / 2; v += step) out.push(Number(v.toFixed(10)));
  return out;
}

/** "$12K", "$1.2M", "$800": axis ticks, compact from a thousand up. */
export function compactMoney(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `$${trim(n / 1_000_000)}M`;
  if (Math.abs(n) >= 1000) return `$${trim(n / 1000)}K`;
  return `$${Math.round(n)}`;
}
const trim = (n: number) => (Number.isInteger(n) ? String(n) : n.toFixed(1).replace(/\.0$/, ""));

export const percent = (n: number) => `${(n * 100).toFixed(n > 0 && n < 0.1 ? 1 : 0)}%`;

/** "Oct 14" from 2026-10-14, read as a calendar date (never shifted by a time zone). */
export function dayLabel(iso: string, withYear = false): string {
  const [y, m, d] = iso.split("-").map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    ...(withYear && { year: "numeric" }),
    timeZone: "UTC",
  });
}

export function monthLabel(iso: string): string {
  const [y, m] = iso.split("-").map(Number) as [number, number];
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString("en-US", {
    month: "short",
    year: "2-digit",
    timeZone: "UTC",
  });
}
